export default [ // 消息管理
    {   // 消息管理--消息场景
        path: '/newsmanage/scene',
        name: 'scene_index',
        component: (() => import('@/views/newsmanage/scene/index.vue')),
        meta: { title: '消息管理', type: 'newsmanage' },
    },
];